import { extend } from 'flarum/common/extend';
import humanTime from 'flarum/common/utils/humanTime';
import PostMeta from 'flarum/forum/components/PostMeta';

function fullTimestamp(time) {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(time));
}

export default function configurePostTimestampDisplay() {
  extend(PostMeta.prototype, 'viewItems', function (items) {
    const time = this.attrs.post.createdAt();
    const timestamp = new Date(time);

    items.replace(
      'time',
      <a className="Dropdown-toggle" onclick={(event) => this.selectPermalink(event)} data-toggle="dropdown">
        <time pubdate datetime={timestamp.toISOString()} title={humanTime(time)}>
          {fullTimestamp(time)}
        </time>
      </a>
    );
  });
}
